import React, { useRef } from "react";
import { useTranslation } from "react-i18next";

import "./AllGamesSection.scss";
import useInfiniteGamesQuery from "../../../../react-query/queries/use-infinite-games";
import GameTile from "../../GameTile/GameTile";
import useIntersectionObserver from "../../../../hooks/useIntersectionObserver";
import { CustomSpinner } from "../../../CustomSpinner/CustomSpinner";
import { GamesLoadingSkeleton } from "../MostPopularGamesSection/MostPopularGamesSection";

const GAMES_PER_PAGE = 12;

function AllGamesSection() {
  const { t } = useTranslation("dashboard");
  const { allGames, query } = useInfiniteGamesQuery({ limit: GAMES_PER_PAGE });
  const sentinelRef = useRef<HTMLDivElement>(null);

  useIntersectionObserver({
    targetRef: sentinelRef,
    options: { threshold: 1.0 },
    callback: ([entry]) =>
      entry.isIntersecting && query.hasNextPage && query.fetchNextPage(),
  });

  if (query.isLoading) return <GamesLoadingSkeleton />;

  return (
    <section className="all-games-section">
      <h2 className="heading">{t("all_games")}</h2>
      <div className="games-container">
        {allGames?.map(({ name, slug, thumbnail }) => (
          <GameTile
            key={slug ?? name}
            name={name}
            slug={slug}
            thumbnail={thumbnail}
          />
        ))}
      </div>
      <div ref={sentinelRef} style={{ height: 1 }} />
      {query.isFetchingNextPage && (
        <div className="d-flex justify-content-center pt-2">
          <CustomSpinner size="sm" className="spinner" />
        </div>
      )}
    </section>
  );
}

export default AllGamesSection;
